module.exports = __webpack_public_path__ + "static/media/edit-icon.a80a198a.svg";